export const urlConfigs = {
    "BASE_URL": process.env.REACT_APP_BASE_URL || "http://dev02.xtremeweb.com.au/html2/gym-management/backend/www",
    "LOCAL_URL": process.env.REACT_APP_LOCAL_URL || "http://192.168.1.215:3000/admin/",
};
